<template>
  <v-content>
    <v-container fluid>
      <OLoadingDialog :value="isLoading" />

      <v-card>
        <v-toolbar class="card-bar">
          <v-toolbar-title>Sources</v-toolbar-title>
          <v-btn icon class="ml-2" @click="reload">
            <v-icon>refresh</v-icon>
          </v-btn>
          <v-spacer />
          <v-text-field
            v-model="txtFilter"
            append-icon="search"
            label="Filtro por nome..."
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>

        <ODataTable
          :items="filteredRows"
          :spec="spec"
          @rowClicked="r => go(r)"
        />
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import _ from 'lodash'
import { Source } from './models'
import OLoadingDialog from 'oderon-vue/cpts/OLoadingDialog'
import ODataTable from 'oderon-vue/cpts/ODataTable'
import { matchAny } from '@/utils'
import { brLongDateTime } from 'oderon-commons/src/formatters'

function typeColor(x) {
  if (x == 'infra') return 'red'
  if (x == 'prd') return 'blue'
  if (x == 'hlg') return 'amber darken-2'
  return 'green'
}

export default {
  components: { OLoadingDialog, ODataTable },
  data() {
    return {
      isLoading: false,
      txtFilter: '',
      rows: [],
      spec: {
        defaultSortable: false,
        columns: [
          { t: 'Source', d: 'name' },
          {
            t: 'Type|',
            d: r => {
              return { labelText: r.type, labelColor: typeColor(r.type) }
            }
          },
          // { t: 'Count|', d: 'stats.count' },
          // { t: 'Min Date|', d: 'stats.minDate', f: brLongDateTime },
          { t: 'Atualizado em|', d: 'updatedAt', f: brLongDateTime }
        ]
      }
    }
  },
  computed: {
    filteredRows() {
      return _.filter(this.rows, r => matchAny(this.txtFilter, r.name, r.type))
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    reload() {
      this.$loading(this.fetchData())
    },
    fetchData() {
      return Source.findAll({ includeStats: true }).then(data => {
        data.forEach(r => (r.type = getType(r)))
        this.rows = data
      })
    },
    go(source) {
      this.$router.push({ path: '/beeper/timeline?sources=' + source.name })
    }
  }
}

function getType(source) {
  if (source.name.indexOf('receiver') != -1) return 'infra'
  if (source.name.indexOf('voluman') != -1) return 'infra'
  if (source.name.indexOf('watchdog') != -1) return 'infra'
  if (source.name.indexOf('hlg') != -1) return 'hlg'
  if (source.name.endsWith('dev')) return 'dev'
  return 'prd'
}
</script>

<style></style>
